import { DeepWriteable } from "../type-utilities";
import { LegalStructure } from "../odo/IOdoCompany";
import { IFundingSource } from "./IFundingSource";
import { EKybStatus } from "../kyb";
import { CustomerAccountContact } from "./CustomerAccountContact";

export const ECustomerAccountStatus = {
  INITIAL_ONBOARDING: "initial_onboarding",
  PAYMENT_PERMISSION_PENDING: "payment_permission_pending",
  LIVE: "live",
  OFFBOARDED: "offboarded",
} as const;

export type ECustomerAccountStatus =
  (typeof ECustomerAccountStatus)[keyof typeof ECustomerAccountStatus];

export const EOwnerType = {
  "Authorized Signer": "authorized_signer",
  "Beneficial Owner": "beneficial_owner",
} as const;

export type EOwnerType = (typeof EOwnerType)[keyof typeof EOwnerType];

export const ECustomerAccountType = {
  AUTO_DEBIT: "auto_debit",
  INVOICE: "invoice",
  PRE_FUNDED: "pre_funded",
} as const;

export type ECustomerAccountType =
  (typeof ECustomerAccountType)[keyof typeof ECustomerAccountType];

export interface IBusinessOwner {
  readonly first_name?: string;
  readonly last_name?: string;
  readonly email?: string;
  readonly ssn?: string;
  readonly dob?: string;
  readonly title?: string;
  readonly ownership_percentage?: number;
  readonly owner_type?: EOwnerType;
  readonly address?: string;
  readonly address_line2?: string | null;
  readonly city?: string;
  readonly state?: string;
  readonly zip?: string;
  readonly ssn_verification_status?: string;
  readonly ssn_verification_error?: string;
}
export interface ICustomerAccount {
  readonly bank_account_verified: boolean;
  readonly business_address?: string;
  readonly business_city?: string;
  readonly business_name: string;
  readonly business_owner?: IBusinessOwner;
  readonly business_state?: string;
  readonly business_zip?: string;
  readonly code?: string;
  readonly company_id: string;
  readonly contacts?: CustomerAccountContact[];
  readonly customer_account_id: string;
  readonly ein?: string;
  readonly email?: string;
  readonly funding_source?: IFundingSource;
  readonly kyb_status?: EKybStatus;
  readonly legal_structure?: LegalStructure;
  readonly odo_user_id?: string;
  readonly onboarded: boolean;
  readonly partner_id: string;
  readonly phone?: string;
  readonly status: ECustomerAccountStatus;
  readonly type: ECustomerAccountType;
}

export interface IRawCustomerAccount
  extends Omit<DeepWriteable<ICustomerAccount>, "funding_source" | "code"> {
  is_test: boolean;
  funding_source_id?: string | null;
  code?: string | null;
}

export interface IRawCustomerAccountWithFunding extends IRawCustomerAccount {
  funding_source?: IFundingSource;
}
